<script setup>
import { defineProps} from "vue";
import NotaFiscalService from "@/api/v2/services/NotaFiscalService";

//==================================================================//
//========================= Props & Emits ==========================//
//==================================================================//

const props = defineProps([
    "controlesDesativados",
    "gerandoRecebimentos",
    "dado",
]);

//==================================================================//
//=================== Pega Nota Fiscal Emitida =====================//
//==================================================================//

const pegaNotaFiscalEmitida = async ()=>{

    let notaFiscalResponse = await NotaFiscalService.getNotaFiscalByPlugNotasId({
        nomeArquivo: props?.dado?.chaveAcesso,
        plugNotasId: props?.dado?.plugNotasID
    });
    if(notaFiscalResponse.status != "200"){
        throw new Error(`${notaFiscalResponse.message}`)
    }

};

</script>

<template>

    <v-card class="c-cartao">

        <v-card-title class="c-cartao__header">

            <div class="c-header__visualizar">
                <v-tooltip bottom>

                    <template v-slot:activator="{ on, attrs }">

                        <v-btn
                            class="c-visualizar-nota-fiscal-emitida mx-2"
                            fab
                            dark
                            small
                            color="#3E737B"
                            v-bind="attrs"
                            v-on="on"
                            @click="pegaNotaFiscalEmitida"
                        >

                            <v-icon dark>
                                mdi-eye
                            </v-icon>
                        
                        </v-btn>

                    </template>

                    <span>
                        Visualizar Nota Fiscal Emitida
                    </span>

                </v-tooltip>
            </div>

            <h3 class="c-header__titulo">
                {{props?.dado?.origem}} {{props?.dado?.codigo}} - Job {{props?.dado?.jobCodigo}}
            </h3>

        </v-card-title>

    </v-card>

</template>

<style scoped>

.c-cartao__header{
    display: grid; 
    grid-template-columns: max-content 1fr; 
    grid-template-rows: 1fr; 
    gap: 10px; 
    grid-template-areas: 
        "visualizar titulo";
}

.c-header__visualizar{
    grid-area: visualizar;
}

.c-header__titulo{
    grid-area: titulo;
}

.theme--dark.v-btn.v-btn--disabled.v-btn--has-bg.c-visualizar-nota-fiscal-emitida{
    background: #3E737B !important;
    border-color: #3E737B !important;
}

</style>